import React, { useState, useEffect, useRef, useMemo } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
// import TextField from "@mui/material/TextField";
import TextField from '@mui/material/TextField';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#fff',
    display: "flex",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-root": {
      height: "45px",
    },
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
    "& .MuiInputLabel-outlined": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
      transform: "translate(14px, 13px) scale(1)",
      color: "rgba(0, 0, 0, 0.54) !important",
    },
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      transform: "translate(14px, -6px) scale(0.75)",
      color: "rgba(0, 0, 0, 0.54) !important",
    },
    "& .Mui-disabled": {
      color: "#000000",
    },
    '& .MuiOutlinedInput-root': {
      '&:hover fieldset': {
        borderColor: '#605f70',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#605f70',
      },
    },
  },
}));

export default function IntInputUn(props) {
  const {
    inputTitle,
    intInput,
    handleIntInputChange,
    name,
    isRequired,
    max,
    min,
  } = props;

  const classes = useStyles();

  return (
    <div className={classes.input}>
      {/* <text className={classes.inputTitle}>{inputTitle}</text> */}
      <TextField
        disabled={props.disabled}
        variant="outlined"
        id={`${inputTitle}-required-outlined-size-small`}
        name={name}
        label={inputTitle}
        type="number"
        InputProps={{ inputProps: { min: min, step: 1, max: max } }}
        style={{ margin: "2px 8px" }}
        defaultValue={typeof intInput === "string" ? intInput?.replace(",", ".") : intInput}
       // value={typeof intInput === "string" ? intInput?.replace(",", ".") : intInput}
        onBlur={handleIntInputChange}
        className={classes.textField}
        required={isRequired}
        inputProps={{
          maxLength: 100,
        }}
      />
    </div>
  );
}

IntInputUn.defaultProps = {
  isRequired: false,
  max: 999999999999,
  min: -999999999999,
};

IntInputUn.propTypes = {
  isRequired: PropTypes.bool,
  inputTitle: PropTypes.any,
  intInput: PropTypes.any,
  handleIntInputChange: PropTypes.any,
  max: PropTypes.number,
  min: PropTypes.number,
};
